// Utils
import { getBreadthFirstBreadcrumb, getPhysicalOrSingleSharedBoardBreadcrumb } from './breadcrumbPathSearch';
import { chooseBreadcrumb } from './breadcrumbResultUtil';
import { getPreferredAliasBreadcrumb } from './breadcrumbPreferredAliasPathUtil';

// Types
import { IdGraph } from '../../../../common/dataStructures/graphTypes';
import { ImMNElementMap } from '../../../../common/elements/elementModelTypes';
import { BreadcrumbResult, PreferredAliasIdByBoardId } from '../breadcrumbTypes';

export type { BreadcrumbResult, PreferredAliasIdByBoardId } from '../breadcrumbTypes';

/**
 * Retrieves the breadcrumb to use for the current board.
 */
export const calculateBreadcrumbs = (
    currentBoardId: string,
    rootBoardId: string,
    elements: ImMNElementMap,
    aclIds: string[],
    boardIdToAliasIdsMap: IdGraph,
    preferredAliasIdByBoardId?: PreferredAliasIdByBoardId,
): BreadcrumbResult => {
    // First, try to get a breadcrumb that follows our preferred aliases defined by navigation
    const preferredBreadcrumb = getPreferredAliasBreadcrumb(
        currentBoardId,
        rootBoardId,
        elements,
        aclIds,
        boardIdToAliasIdsMap,
        preferredAliasIdByBoardId,
    );

    // If that's valid, use it; otherwise, fall back to the physical breadcrumb or breadth-first search
    if (preferredBreadcrumb?.complete && !preferredBreadcrumb.detached) return preferredBreadcrumb;

    const fallbackBreadcrumb =
        getPhysicalOrSingleSharedBoardBreadcrumb(currentBoardId, rootBoardId, elements, aclIds, boardIdToAliasIdsMap) ||
        getBreadthFirstBreadcrumb(
            currentBoardId,
            rootBoardId,
            elements,
            aclIds,
            boardIdToAliasIdsMap,
            preferredAliasIdByBoardId,
        );

    return chooseBreadcrumb(preferredBreadcrumb, fallbackBreadcrumb) || fallbackBreadcrumb;
};
